import type { ReactElement } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';

/**
 * Inline notice rendered above the Preferences "Appearance" section when the
 * boot-time `usePreferencesQuery()` failed. The user keeps using the theme
 * sourced from localStorage; this lets them know the cloud copy could not be
 * fetched.
 *
 * The shadcn `<Alert>` primitive sets `role="alert"` internally — do not
 * pass it explicitly.
 */
export function PreferencesSyncNotice(): ReactElement {
  return (
    <Alert variant="destructive">
      <AlertDescription>
        Couldn&apos;t sync your preferences. Showing your last saved theme.
      </AlertDescription>
    </Alert>
  );
}
